module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Article.88f7f120.jpg";